export const TOAST_LIFE_TIME_MS = 3200
export const toast = ref<ReturnType<typeof useToast>>()
export const toastErrorMessage = ref('')

interface ShowToastOptions {
  summary: string
  detail: string
  life?: number
}

export const showSuccessToast = ({ summary, detail, life }: ShowToastOptions): void => {
  toast.value?.add({
    severity: 'success',
    summary,
    detail,
    life: life ?? TOAST_LIFE_TIME_MS
  })
}

export const showErrorToast = ({ summary, detail, life }: ShowToastOptions): void => {
  toast.value?.add({
    severity: 'error',
    summary,
    detail,
    life: life ?? TOAST_LIFE_TIME_MS
  })
}

export const showWarningToast = ({ summary, detail, life }: ShowToastOptions): void => {
  toast.value?.add({
    severity: 'warn',
    summary,
    detail,
    life: life ?? TOAST_LIFE_TIME_MS
  })
}
